// @theme component
export const enum AdditionalAssetsValues {
    HLS = 'HLS_URL',
    MAIN_IMAGE_ROUNDED = 'MAIN_IMAGE_ROUNDED',
    MOBILE_IMAGE_ROUNDED = 'MOBILE_IMAGE_ROUNDED',
    LIVE_DATA_TYPE = 'LIVE_DATA_TYPE',
    WC_REPLACER_ID = 'WC_REPLACER_ID'
}

export const enum LiveDataTypes {
    BLACKJACK = 'Blackjack',
    ROULETTE = 'Roulette',
    BACCARAT = 'Baccarat'
}
